import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import { useDcStore } from '../stores/dcStore'
import { useCalculatorLogic } from '../hooks/useCalculatorLogic'
import { RackParametersPanel } from '../components/calculator/RackParametersPanel'
import { SummaryPanel } from '../components/calculator/SummaryPanel'
import { DcMapSVG } from '../components/calculator/DcMapSVG'

export default function CalculatorPage() {
  const { code: dcCode } = useParams<{ code: string }>()
  const navigate = useNavigate()
  const { datacenters: dcs, loading: dcLoading } = useDcStore()
  const currentDc = dcs.find(d => d.code === dcCode)

  useEffect(() => {
    if (!dcLoading && dcs.length > 0 && !currentDc) {
      toast.error(`Datacenter "${dcCode}" not found.`)
      navigate('/')
    }
  }, [dcLoading, currentDc, dcCode, dcs.length, navigate])

  const {
    racks, src, setSrc, srcU, setSrcU, tgt, setTgt, tgtU, setTgtU,
    cable, setCable, loading, error, setError, result, setResult,
    history, handleSwap, handleCalc, handleRackClick
  } = useCalculatorLogic(dcCode, currentDc)

  return (
    <div className="h-full flex overflow-hidden">
      {/* ── Left sidebar (params + results) ── */}
      <div className="w-[280px] shrink-0 flex flex-col border-r border-border bg-bg-panel overflow-y-auto">

        {/* Header */}
        <div className="px-3 py-2.5 border-b border-border shrink-0">
          <h1 className="text-sm font-semibold text-text-primary">Калькулятор кабелей</h1>
          <p className="text-[10px] text-text-muted mt-0.5">Кликните по стойке на схеме для выбора</p>
        </div>

        {/* ── Params section ── */}
        <RackParametersPanel
          dcs={dcs}
          dcCode={dcCode}
          currentDc={currentDc}
          racks={racks}
          src={src}
          tgt={tgt}
          srcU={srcU}
          tgtU={tgtU}
          cable={cable}
          loading={loading}
          setSrc={setSrc}
          setTgt={setTgt}
          setSrcU={setSrcU}
          setTgtU={setTgtU}
          setCable={(c) => { setCable(c); setResult(null); }}
          handleSwap={handleSwap}
          handleCalc={handleCalc}
        />

        {/* ── Results section ── */}
        <SummaryPanel
          result={result}
          error={error}
          src={src}
          tgt={tgt}
          dcCode={dcCode}
          cable={cable}
          racks={racks}
          currentDc={currentDc}
          history={history}
          setSrc={setSrc}
          setTgt={setTgt}
          setCable={setCable}
          setResult={setResult}
          setError={setError}
        />
      </div>

      {/* ── Right: full SVG DC map ── */}
      <div className="flex-1 overflow-hidden bg-bg-app">
        <DcMapSVG
          racks={racks}
          route={result?.route ?? []}
          srcId={src?.id}
          tgtId={tgt?.id}
          onRackClick={handleRackClick}
          dc={currentDc}
          totalLength={result?.total_length}
        />
      </div>
    </div>
  )
}
